module.exports = __webpack_public_path__ + "img/inst-colored.a5cf3de7.svg";